import firbase from "firebase";
import "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD928X4o5IPZ_zZRa8GZfXGgI_vWMFtMac",
  authDomain: "todosapp-aa69d.firebaseapp.com",
  projectId: "todosapp-aa69d",
  storageBucket: "todosapp-aa69d.appspot.com",
  messagingSenderId: "756829063284",
  appId: "1:756829063284:web:a08e8d95a18c22ca94e921",
  measurementId: "G-EGX9HFLH4D",
};

//initilize firbase
export const db = firbase.initializeApp(firebaseConfig).firestore();
